import {makeAutoObservable, reaction} from "mobx";
import {DialogStoreInterface} from "../DialogStore";
import {VhsPrinterItem, vhsPrinterStore} from "./VhsPrinterStore";
import {DocumentTypeDto} from "../../api/vhs";
import {api, catchApi} from "../../api";
import {userPrinterPreferenceStore} from "../ums";


interface DocInfo {
    customerId: string
    documentId: string
    vin: string
    location?: string
    type: DocumentTypeDto
}

class VhsLabelPrintDialogStore implements DialogStoreInterface {
    get document(): DocInfo | undefined {
        return this._document;
    }

    set document(value: DocInfo | undefined) {
        this._document = value;
    }
    get printer(): VhsPrinterItem | undefined {
        return this._printer;
    }

    set printer(value: VhsPrinterItem | undefined) {
        this._printer = value;
    }
    get executing(): boolean {
        return this._executing
    }

    set executing(value: boolean) {
        this._executing = value
    }
    get dialogErrorMessage(): string | undefined {
        return this._dialogErrorMessage
    }

    set dialogErrorMessage(value: string | undefined) {
        this._dialogErrorMessage = value
    }
    get dialogOpen(): boolean {
        return this._dialogOpen
    }

    set dialogOpen(value: boolean) {
        this._dialogOpen = value
    }
    private _dialogOpen: boolean = false
    private _dialogErrorMessage?: string | undefined
    private _executing: boolean = false

    private _printer: VhsPrinterItem | undefined
    private _document: DocInfo | undefined

    constructor() {
        makeAutoObservable(this)
        reaction(() => [
            userPrinterPreferenceStore.zebraPrinterId,
            vhsPrinterStore.options
        ], () => this.resetDefaultPrinter())
    }

    resetDefaultPrinter() {
        const printerId = userPrinterPreferenceStore.zebraPrinterId
        const options = vhsPrinterStore.options
        this.printer = options.find(p => p.id === printerId) || undefined
    }

    async triggerLabelPrint(): Promise<boolean> {
        this.executing = true
        const {
            customerId,
            vin,
            documentId,
            type
        } = this.document || {}
        const printerId = this.printer?.id
        if (
            !printerId ||
            !customerId ||
            !vin ||
            !documentId ||
            !type
        ) {
            this.executing = false
            return false
        }
        const result = await catchApi(async () => await api.vhs.api.triggerLabelPrint({
            printerId: printerId,
            vin: vin,
            customerId: customerId,
            documentId: documentId,
            documentType: type
        }))

        this.executing = false
        return result?.data || false
    }
}

export {
    VhsLabelPrintDialogStore
}
